// components/Tabs.jsx
import { useState, useEffect } from 'react';
import { FiGrid, FiHome, FiMapPin, FiAlertCircle, FiFileText } from 'react-icons/fi'; // lightweight sharp icons

export default function CSTabs({ handelTabs, centerTab,tabType }) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640); // Tailwind sm breakpoint
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const tabs = [
    { id: 'tab1', label: 'All'},
    { id: 'tab2', label: 'Remote'},
    { id: 'tab3', label: 'InPerson'},
    { id: 'tab4', label: 'Urgent'},
    { id: 'tab5', label: 'General'},
  ];

  return (
    <div className="bg-white lg:bg-neutral-100 md:bg-neutral-100 rounded-lg p-2 flex items-center gap-1 overflow-x-auto" id="tabs-container">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          id={tab.id}
          className={`tabBtn px-4 py-2 text-coalBlack baseText !font-medium rounded-md capitalize whitespace-nowrap flex items-center justify-center
            ${tabType === tab.label ? 'bg-accent text-white':'bg-transparent text-coalBlack'} `
            
          }
          onClick={(e) => {
            handelTabs(e, tab.label);
            centerTab(tab.id);
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
